<template>
  <MinimalLayout :loading="step === 'loading'">
    <SuccessStatus v-if="step === 'completed'" :message="t('liveness.completed')" />
    <SuccessStatus v-else-if="step === 'refused'" :message="t('liveness.refused')" />

    <ExpiredSentStatus v-else-if="step === 'expired'" :message="t('liveness.expired')" />

    <ErrorStatus v-else-if="step === 'aborted'">{{ t("liveness.aborted") }}</ErrorStatus>

    <ErrorStatus v-else>{{ t("liveness.errorOccurred") }}</ErrorStatus>
  </MinimalLayout>
</template>

<script lang="ts" setup>
import ErrorStatus from "@/components/ErrorStatus.vue";
import ExpiredSentStatus from "@/components/ExpiredSentStatus.vue";
import MinimalLayout from "@/components/MinimalLayout.vue";
import SuccessStatus from "@/components/SuccessStatus.vue";
import { useI18n } from "@/composables/useI18n";
import { captureException } from "@sentry/vue";
import { ref } from "vue";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const step = ref<"loading" | "completed" | "aborted" | "expired" | "refused" | "error">("loading");

(() => {
  try {
    // https://docs.treezor.com/guide/user-verification/live-verification.html#initiate-a-live-verification
    const responseCode =
      typeof route.query.response_code === "string" ? route.query.response_code : undefined;
    const event = typeof route.query.event === "string" ? route.query.event : undefined;

    if (event === "identity_verification_capture_completed") {
      step.value = "completed";
      return;
    }
    if (event === "identity_verification_capture_aborted") {
      step.value = "aborted";
      return;
    }
    if (event === "identity_verification_link_expired") {
      step.value = "expired";
      return;
    }
    if (event === "identity_verification_capture_refused") {
      step.value = "refused";
      return;
    }

    console.error("Unexpected Treezor liveness return query", {
      query: route.query,
      event,
      responseCode,
    });
    captureException(new Error("Unexpected Treezor liveness return query"), {
      extra: { query: route.query, event, responseCode },
    });
    step.value = "error";
  } catch (cause) {
    const error = new Error("Error in Liveness Return init function", { cause });
    console.error(error);
    captureException(error);
    step.value = "error";
  }
})();
</script>
